interface PermissionEntry {
  permissionDescriptionId: string;
  value: boolean;
}

export const isPermissionInCollection = (
  collection: PermissionEntry[] | undefined,
  permissionDescriptionId: string,
): boolean =>
  collection?.some(
    (el) =>
      el.permissionDescriptionId === permissionDescriptionId && el.value,
  ) ?? false;

export const buildPermissionsMap = (
  permissions: PermissionEntry[] | undefined,
): Record<string, boolean> =>
  permissions?.reduce<Record<string, boolean>>((acc, access) => {
    acc[access.permissionDescriptionId] = access.value;
    return acc;
  }, {}) ?? {};
